export class Subject {
  
  callbackArray: Function[] = [];

  constructor() {}

  subscribe(subscription: Function) {
    this.callbackArray.push(subscription);
  }

  next() {
    this.callbackArray.forEach(e => e());
  }

}